import { JsonPatchOperation } from "_shared/_api/attorney-hub-api-service";
import MarketplaceFeeScheduleCategoryAPIRequest from "marketplace/teams/fee-schedules/categories/_api/commands/marketplace-fee-schedule-category-api-command";
import FeeSchedule from "marketplace/teams/fee-schedules/fee-schedule";

export default class UpdateFeeScheduleCommand {
  payload: JsonPatchOperation[] = [];

  constructor(original: FeeSchedule, updated: FeeSchedule) {
    if (updated.name !== original?.name)
      this.payload.push({
        op: "replace",
        path: "/name",
        value: updated.name,
      });
    if (!UpdateFeeScheduleCommand.haveSameTags(original, updated))
      this.payload.push({
        op: "replace",
        path: "/tags",
        value: updated.tags,
      });
    if (!UpdateFeeScheduleCommand.haveSameCategories(original, updated)) {
      this.payload.push({
        op: "replace",
        path: "/categories",
        value: updated.categories.map(
          (category) => new MarketplaceFeeScheduleCategoryAPIRequest(category)
        ),
      });
    }
  }

  static haveSameTags(original: FeeSchedule, updated: FeeSchedule): boolean {
    if (original.tags.length !== updated.tags.length) {
      return false;
    }
    const originalTags = original.tags.map((tag) => tag.value);
    const updatedTags = updated.tags.map((tag) => tag.value);
    for (let i = 0; i < updatedTags.length; i++) {
      if (!originalTags.includes(updatedTags[i])) {
        return false;
      }
    }
    return true;
  }

  static haveSameCategories(
    original: FeeSchedule,
    updated: FeeSchedule
  ): boolean {
    if (original.categories.length !== updated.categories.length) {
      return false;
    }
    for (let i = 0; i < updated.categories.length; i++) {
      if (
        !original.categories.find((category) =>
          category.isEqualTo(updated.categories[i])
        )
      )
        return false;
    }
    return true;
  }
}
